import axiosClient from './axiosClient';
import { API_URLS } from '../constants/apiUrls';

const globalMapApi = {
  getListOfLocations: (ownerId: number, date: string, routeType: string) => {
    console.log(ownerId, date, routeType, 'this is the value of the props');
    return axiosClient.get(
      `${'/track/locations/list/'}?ownerId=${ownerId}&date=${date}&routeType=${routeType}`,
    );
  },
};

export default globalMapApi;
